import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { Button, SaveButton } from "../../../components/Buttons";

export const Order = () => {
    document.title = "Sifariş";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Satışlar", value: "/demands" },
        { name: "Sifariş", value: "/demands/order", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Sifariş</h2>
                    <p>
                        Sifariş sənədi, müştərilərdən gələn sifarişlərin formalaşdırılması üçün nəzərdə tutulub. Sifariş sənədi yaratmaq üçün nümunədəki
                        ardıcıllığı icra etmək lazımdır. Yeni sifariş düyməsi ilə açılan pəncərədə sifariş olunacaq məhsulları əlavə edib Yadda saxla düyməsini
                        sıxmaq lazımdır.
                    </p>
                    <img src="/images/demands/order-1.gif" alt="Sifariş" />
                    <p>
                        Sifariş sənədini yadda saxladıqdan sonra, sənədi tərk etmədən sifariş sənədini <Link to={"/demands/demand"}>Satış</Link> sənədinə
                        çevirmək olar. <Button>Sənəd yarat</Button> düyməsi ilə sifariş edilən məhsulların satış sənədi açılacaq. <SaveButton /> düyməsi ilə
                        satış sənədini yaratmaq olar.
                    </p>
                    <img src="/images/demands/order-2.gif" alt="Sifariş" />
                </article>
            </div>
        </div>
    );
};
